@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';
@import '../../../constants/transitions.module.less';
@import '../../../constants/z-index.module.less';
@import '../../../constants/mixins.module.less';

.notification-manager {
  position: fixed;
  top: 50px;
  right: 0;
  z-index: @z-notification-manager;
  transition: right @transition-sidebar-shift;
  max-width: 100vw;
  .shift-for-sidebar();
}

.notifications {
  position: relative;
}

.notification-wrapper {
  position: relative;
  margin-top: 10px;
  margin-right: 10px;
  transition:
    right 300ms ease,
    max-height 300ms ease 300ms;
  max-height: 1000px;
  overflow: hidden;
  box-shadow: 0 5px 10px @notification-manager--box-shadow-color;
  border-radius: 0 0 4px 4px;

  &.removed {
    right: -1000px;
    max-height: 0;
  }
}
